/**
 * Barra superior de la consola: navegacion y cierre de sesion global.
 *
 * El branding replica la barra de las aplicaciones de la organizacion:
 * fondo navy, wordmark con la marca y la aplicacion, navegacion en
 * mayusculas con subrayado en la seccion activa.
 */

import { Link, NavLink } from 'react-router-dom';
import { routes } from '@presentation/router/routes';
import { useAuthContext } from '@presentation/context/AuthContext';
import styles from './Header.module.css';

/** Iniciales para el avatar: "Bernardo Veht" -> "BV". */
function initials(fullName: string, email: string): string {
  const [first, second] = fullName.trim().split(/\s+/).filter(Boolean);

  if (first && second) {
    return `${first[0]}${second[0]}`.toUpperCase();
  }

  return (first ?? email).slice(0, 2).toUpperCase();
}

export function Header() {
  const { isAuthenticated, session, logout } = useAuthContext();

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to={routes.users} className={styles.brand}>
          <span className={styles.brandMark}>SC</span>
          <span className={styles.brandText}>
            <span className={styles.brandName}>SCOPESI</span>
            <span className={styles.brandSub}>Consola SSO</span>
          </span>
        </Link>

        <nav className={styles.nav}>
          {isAuthenticated && (
            <>
              <NavLink to={routes.users} className={styles.navLink}>
                Usuarios
              </NavLink>
              <NavLink to={routes.roles} className={styles.navLink}>
                Roles
              </NavLink>
              <NavLink to={routes.applications} className={styles.navLink}>
                Aplicaciones
              </NavLink>
            </>
          )}
        </nav>

        <div className={styles.auth}>
          {isAuthenticated && session ? (
            <>
              <span className={styles.avatar} aria-hidden="true">
                {initials(session.fullName, session.email)}
              </span>
              <span className={styles.userName}>{session.email}</span>
              <button onClick={() => void logout()} className={styles.logoutButton}>
                Salir
              </button>
            </>
          ) : (
            <Link to={routes.login} className={styles.loginLink}>
              Ingresar
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
